<template lang="pug">
  .detour_home
    vue-headful(
      :title="title"
    )
    .detour_home__menu
      el-row(:gutter="50" type="flex" justify="center")
        el-col(:lg="11" :md="11" :sm="11" :xs="11")
          h2 Financial Assumptions
          el-radio-group(
            v-model="financialAssumptionsSwitch"
          )
            el-radio-button(label="Base Case")
            el-radio-button(label="Spot Case")
            el-radio-button(label="User Case")
          slider(
              :min="1000"
              :step="25"
              :max="2000"
              :custom-formatter="v => `${Math.round(v)} (US$/oz)`"
              v-model='financialInputs.goldPrice'
              title='Gold Price'
              :baseValue='baseCaseFinancialAssumptions.goldPrice'
              :hide='true'
          )
          slider(
              :min="10"
              :step="0.25"
              :max="20"
              :custom-formatter="v => `${Math.round(v)} (US$/oz)`"
              v-model='financialInputs.silverPrice'
              title='Silver Price'
              :baseValue='baseCaseFinancialAssumptions.silverPrice'
              :hide='true'
          )
          slider(
            :min="0"
            :step="0.01"
            :max="0.15"
            :custom-formatter="v => `${Math.round(v*100)}%`"
            v-model='financialInputs.discountRate'
            title='Discount Rate'
            :hide='false'
          )
          slider(
            :min="0.65"
            :step="0.01"
            :max="1.65"
            :custom-formatter="v => `${v}`"
            v-model='financialInputs.USDCAD'
            title='FX Rate (USD:CAD)'
            :hide='false'
          )

          h2 Technical Assumptions
          el-radio-group(
            v-model="technicalAssumptionsSwitch"
          )
            el-radio-button(label="Base Case")
            el-radio-button(label="User Case")
          slider(
              :min="0"
              :step="0.1"
              :max="5"
              :custom-formatter="v => `${Math.round(v * 100)/100}`"
              v-model='technicalInputs.heapLeachGoldGrade'
              title='Heap Leach Gold Grade'
              :hide='true'
              :baseValue='baseCaseTechnicalAssumptions.heapLeachGoldGrade'
            )
          slider(
              :min="0"
              :step="0.1"
              :max="5"
              :custom-formatter="v => `${Math.round(v * 100)/100}`"
              v-model='technicalInputs.millGoldGrade'
              title='Mill Gold Grade'
              :hide='true'
              :baseValue='baseCaseTechnicalAssumptions.millGoldGrade'
          )
          slider(
              :min="0"
              :step="0.5"
              :max="20"
              :custom-formatter="v => `${Math.round(v * 100)/100}`"
              v-model='technicalInputs.heapLeachSilverGrade'
              title='Heap Leach Silver Grade'
              :hide='true'
              :baseValue='baseCaseTechnicalAssumptions.heapLeachSilverdGrade'
          )
          slider(
              :min="0"
              :step="0.5"
              :max="100"
              :custom-formatter="v => `${Math.round(v * 100)/100}`"
              v-model='technicalInputs.millSilverGrade'
              title='Mill Silver Grade'
              :hide='true'
              :baseValue='baseCaseTechnicalAssumptions.millSilverdGrade'
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.heapLeachGoldRecovery'
            :hide='true'
            title='Heap Leach Gold Recovery'
            :baseValue='baseCaseTechnicalAssumptions.heapLeachGoldRecovery'
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.millGoldRecovery'
            :hide='true'
            title='Mill Gold Recovery'
            :baseValue='baseCaseTechnicalAssumptions.millGoldRecovery'
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.heapLeachSilverRecovery'
            :hide='true'
            title='Heap Leach Silver Recovery'
            :baseValue='baseCaseTechnicalAssumptions.heapLeachSilverRecovery'
          )
          slider(
            :min="0"
            :step="0.01"
            :max="1"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.millSilverRecovery'
            :hide='true'
            title='Mill Silver Recovery'
            :baseValue='baseCaseTechnicalAssumptions.millSilverRecovery'
          )
          slider(
            :min="0"
            :step="0.1"
            :max="10"
            :custom-formatter="v => `${v}x`"
            v-model='technicalInputs.stripRatio'
            type="is-green"
            :hide='true'
            title='Strip Ratio'
            :baseValue='baseCaseTechnicalAssumptions.stripRatio'
          )
          slider(
            :min="0"
            :step="0.05"
            :max="3"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.openPitMiningCostPerTonneMined'
            :hide='true'
            title='Open Pit Mining Cost per Tonne Mined'
            :baseValue='baseCaseTechnicalAssumptions.openPitMiningCostPerTonneMined'
          )
          slider(
            :min="0"
            :step="0.05"
            :max="4"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.heapLeachProcessCostPerTonneProcessed'
            :hide='true'
            title='Heap Leach Process Cost per Tonne Processed'
            :baseValue='baseCaseTechnicalAssumptions.heapLeachCostPerTonneProcessed'
          )
          slider(
            :min="0"
            :step="0.25"
            :max="20"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.millProcessCostPerTonneProcessed'
            :hide='true'
            title='Mill Process Cost per Tonne Processed'
            :baseValue='baseCaseTechnicalAssumptions.millProcessCostPerTonneProcessed'
          )
          slider(
            :min="0"
            :step="0.05"
            :max="5"
            :custom-formatter="v => `${Math.round(v * 100)/100}`"
            v-model='technicalInputs.gAndACostPerTonneProcessed'
            :hide='true'
            title='G&A per Tonne Processed'
            :baseValue='baseCaseTechnicalAssumptions.gAndACostPerTonneProcessed'
          )

          slider(
            :min="-0.3"
            :step="0.05"
            :max="0.3"
            :custom-formatter="v => `${Math.round(v * 100)}%`"
            v-model='technicalInputs.sustainingCapexVariance'
            :hide='false'
            title='Sustaining Capex Variance'
          )

        el-col(:lg="11" :md="11" :sm="11" :xs="11")
          h2 Outputs
          el-row
            el-col(:lg="7" :md="7" :sm="7" :xs="7")
              el-radio-group(
                v-model="currencySwitch"
                size="large"
              )
                el-radio-button(label="USD")
                el-radio-button(label="CAD")
            el-col(:lg="10" :md="10" :sm="10" :xs="10")
              el-radio-group(
                v-model="accountingSwitch"
                size="large"
              )
                el-radio-button(label="By-Product")
                el-radio-button(label="Co-Product")
          .table
            el-table(
              v-loading="tableLoading"
              element-loading-text="Loading..."
              :data="tableData"
            )
              el-table-column(
                prop="field"
                width="150"
              )
              el-table-column(
                prop="units"
                label="Unit"
              )
              el-table-column(
                prop="baseCase"
                label="Base Case"
              )
              el-table-column(
                prop="spotCase"
                label="Spot Case"
              )
              el-table-column(
                prop="userCase"
                label="User Case"
              )

          .charts
              apexchart(
                width="100%"
                height="450"
                :options="productionChartOptions"
                :series="productionChartData"
              )
</template>

<script>
import modelApi from '@/services/ModelApi'
import Slider from '@/components/slider'
import modelMixin from '../mixins/modelMixin'

export default {
  name: 'detour',
  components: { Slider },
  mixins: [modelMixin],
  data: function () {
    return {}
  },
  created () {},
  computed: {
    productionChartOptions () {
      // Dollar charts precede each value on y axis with a "$" sign.
      return {
        chart: {
          id: 'production-chart',
          type: 'bar',
          stacked: true,
          toolbar: {
            show: false
          }
        },
        colors: ['#a8bfac', '#cedbb4', '#b8d9eb'],
        xaxis: {
          categories: this.userCase.years.labels,
          labels: {
            rotate: -45,
            rotateAlways: true
          }
        },
        yaxis: [
          {
            opposite: true,
            title: {
              text: 'AISC ($/oz)',
              style: {
                fontSize: '16px'
              }
            },
            labels: {
              align: 'right',
              formatter: function (value) {
                return typeof value === 'number' ? '$ ' + value.toLocaleString() : value
              }
            }
          },
          {
            seriesName: 'Gold Production',
            title: {
              text: 'Production per Year (koz)',
              style: {
                fontSize: '16px'
              }
            },
            opposite: false,
            stacked: true,
            labels: {
              align: 'right',
              formatter: function (value) {
                return typeof value === 'number' ? value.toLocaleString() : value
              }
            }
          }
        ],
        stroke: {
          show: true,
          width: [3, 0, 0]
        },
        legend: {
          position: 'top'
        },
        dataLabels: {
          enabled: false
        }
      }
    },
    productionChartData () {
      return [
        {
          name: 'All-in-Sustaining Cost',
          type: 'line',
          data: Object.entries(this.userCase.years[this.aiscChartField]).map(([key, value]) => {
            return Math.round(value * this.exchangeRate, 0) || 0
          })
        },
        {
          name: 'Gold Production',
          type: 'column',
          data: Object.entries(this.userCase.years.goldProduction).map(([key, value]) => {
            return Math.round(value, 0) || 0
          })
        }
      ]
    }
  },
  methods: {
    updateSpot () {
      let params = Object.assign({}, this.technicalInputs, this.spotPrices)
      modelApi.fetchModel(
        params, 5
      ).then(response => {
        this.spotCase = response.data
      })
    },
    updateData (params, initialize) {
      modelApi.fetchModel(
        params, 5
      ).then(response => {
        this.userCase = response.data
        if (initialize) {
          this.baseCase = response.data
          this.technicalInputs = {
            'heapLeachGoldRecovery': this.round(response.data.lom.heapLeachGoldRecovery, 2),
            'heapLeachSilverRecovery': this.round(response.data.lom.heapLeachSilverRecovery, 2),
            'millGoldRecovery': this.round(response.data.lom.millGoldRecovery, 3),
            'millSilverRecovery': this.round(response.data.lom.millSilverRecovery, 2),
            'stripRatio': this.round(response.data.lom.stripRatio, 2),
            'openPitMiningCostPerTonneMined': this.round(response.data.lom.openPitMiningCostPerTonneMined, 2),
            'heapLeachProcessCostPerTonneProcessed': this.round(response.data.lom.heapLeachProcessCostPerTonneProcessed, 2),
            'millProcessCostPerTonneProcessed': this.round(response.data.lom.millProcessCostPerTonneProcessed, 2),
            'gAndACostPerTonneProcessed': this.round(response.data.lom.gAndACostPerTonneProcessed, 2),
            'heapLeachGoldGrade': this.round(response.data.lom.heapLeachGoldGrade, 2),
            'millGoldGrade': this.round(response.data.lom.millGoldGrade, 3),
            'heapLeachSilverGrade': this.round(response.data.lom.heapLeachSilverGrade, 2),
            'millSilverGrade': this.round(response.data.lom.millSilverGrade, 2),
            'sustainingCapexVariance': 0,
            'preProductionCapexVariance': 0
          }
          this.financialInputs = {
            'discountRate': response.data.valuation.discountRate,
            'delayStartYear': response.data.valuation.delayStartYear,
            'goldPrice': this.round(response.data.macro.goldPrice, 0),
            'silverPrice': this.round(response.data.macro.silverPrice, 2),
            'USDCAD': this.round(this.dataOrSpot(response.data.macro.USDCAD), 2) // TODO: make this more general
          }
          this.baseCaseFinancialAssumptions = this.copy(this.financialInputs)
          this.baseCaseTechnicalAssumptions = this.copy(this.technicalInputs)
          this.title = response.data.model.assetName
          this.loaded = true
        } else {
          this.buildTable()
        }
      })
    },
    buildTable () {
      this.tableData = [
        this.tableRow('npv'),
        this.tableRow('freeCashFlow'),
        this.tableRow('AISC'),
        this.tableRow('goldProduction')
      ]
      this.tableLoading = false
    }
  },
  watch: {}
}
</script>

<style scoped>
.tooltip {
  font-family: sans-serif;
}

.detour_home {
  background: white;
}

.detour_home .el-table {
  font-size: 16px !important;
}

.detour_home p {
  margin-top: 1px !important;
  margin-bottom: 0 !important;
}

.detour_home h1 {
  font-size: 40px;
  margin-bottom: 0;
}

.detour_home h2 {
  font-size: 21px;
  font-weight: bold;
  margin-top: 17.4px !important;
  margin-bottom: 17.4px !important;
}

.detour_home h3 {
  font-size: 20px;
}

.detour_home h4 {
  color: #555;
  font-weight: 100;
  font-size: 21px;
  margin-top: 6px;
}

.detour_home__menu {
  font-size: 13px;
  line-height: 16px;
  background-color: white;
  box-shadow: 0 0 0 rgba(0, 0, 0, 0.03);
  z-index: 12;
}

.detour_home__menu p,
.detour_home__menu b {
  margin: 0;
}

.detour_home__menu b {
  float: right;
}

.detour_home .el-radio-group {
  margin-bottom: 10px;
  margin-right: 5px;
}

.charts {
  margin-top: 25px;
}

@media screen and (max-width: 1366px) {
  .tooltip {
    display: none;
  }
}
</style>
